import Init from '../containers/Init'
import dashboard from './dashboard'
import events from './events'
import banners from './banners'
import settings from './settings'
import profile from './profile'
import content from './content'

export default [
  {
    key: 'view_root',
    url: '/',
    name: 'App',
    title: 'LOOPI',
    component: Init,
  },
  {
    key: 'view_first_login',
    url: '/first-login',
    name: 'firstLogin',
    title: 'Configuración inicial',
    component: Init,
  },
  {
    key: 'view_forgot_password',
    url: '/forgot-password',
    name: 'forgotPassword',
    title: 'Olvidé mi contraseña',
    component: Init,
  },
  {
    key: 'view_recover_access',
    url: '/recuperar-acceso',
    name: 'recoverAccess',
    title: 'Recuperar acceso',
    component: Init,
  },
  {
    key: 'view_collaborator_invitation',
    url: '/invitacion-colaborador',
    name: 'collaboratorInvitation',
    title: 'Invitación a Loopi',
    component: Init,
  },
  {
    key: 'view_register',
    url: '/register',
    name: 'register',
    title: 'Registrarme',
    component: Init,
  },
  ...dashboard,
  ...events,
  ...banners,
  ...settings,
  ...profile,
  ...content,
]
